import React, { useState } from "react";
import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png';  
import ExecutiveEdu from "./ExecutiveEdu";
import Accomodations from "./Accomodations";
import Admissions from "./Admissions";
import ApplicationAssist from "./ApplicationAssist";
import Payment from "./Payment";
import Other from "./Other";

const LastMenu = ({id}) => {

    const [showMenu, setShowMenu] = useState(true);
    const [showFrame1, setShowFrame1]=useState(false);
    const [showFrame2, setShowFrame2]=useState(false);
    const [showFrame3, setShowFrame3]=useState(false);

  const [time] = React.useState(new Date());
    return(
        <>
            <div className="frame1 animated-frame">
                Did that answer your question?
            </div>
            { showMenu && 
            <div className="menu-btns animated-frame">
                <button className="menu-btn" onClick={() => {
                    setShowMenu(false);
                    setShowFrame1(true);
                    setShowFrame2(false);
                    setShowFrame3(false);
                }}>Yes</button>
                <button className="menu-btn" onClick={() => {
                    setShowMenu(false);
                    setShowFrame1(false);
                    setShowFrame2(true);
                    setShowFrame3(false);
                }}>No, I have more questions</button><br></br>
                <button className="menu-btn" onClick={() => {
                    setShowMenu(false);
                    setShowFrame1(false);
                    setShowFrame2(false);
                    setShowFrame3(true);
                }}>Restart the chat</button>
            </div>}

            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Yes</div>
                </div>
                    <div className="frame1 animated-frame">
                        Akaay : Great! I'm glad I could help. If you have any more questions in the future, feel free to ask. Have a wonderful day!
                    </div>
                </>
            )}

            {showFrame2 && (
                <>
                    {id === 1 && <ExecutiveEdu />}
                    {id === 2 && <Accomodations />}
                    {id === 3 && <Admissions />}
                    {id === 4 && <ApplicationAssist />}
                    {id === 5 && <Payment />}
                    {id === 6 && <Other />}
                </>
            )}

            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}


        </>
    );
}
export default LastMenu;